<div class="dropdown category-dropdown">
  <a href="javascript:;" class="dropdown-toggle" title="Categories" (click)="toggleMenu()">
  Categories</a>

  <div class="dropdown-menu" [class.hide]="!utilsService.isSticky && isHome">
    <nav class="side-nav">
      <ul class="menu-vertical sf-arrows">
        @for (cat of cats; track cat.PCM_Id; let i = $index) {
          <li routerLinkActive="active">
            <!--<a routerLink="/shop/sidebar/3cols" [queryParams]="{category: cat.PCM_Description,id:cat.CATID}">{{cat.PCM_Description}}</a>-->
            <a>{{cat.PCM_Description}}</a>
            <ul>
              @for (subcat of cat.subcategories; track subcat.CatID) {
                <li>
                  <a routerLink={{catsLinkFromParams}}  [queryParams]="{subcategory: subcat.CatID}">{{subcat.CatDescription}}</a>
                </li>
              }
            </ul>
          </li>
        }

      </ul>
    </nav>
  </div>
</div>
